import { render, staticRenderFns } from "./required_label.vue?vue&type=template&id=3604d6fb&scoped=true&"
import script from "./required_label.vue?vue&type=script&lang=js&"
export * from "./required_label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3604d6fb",
  null
  
)

export default component.exports